import React, { useState } from 'react';
import { DatePicker } from 'antd-mobile';
import dayjs from 'dayjs';
import { BASE_IMG_URL } from '@images/imageUrls';
import styles from './index.module.scss';

interface Props {
  title: string;
  value: string;
  onChange: (date: dayjs.Dayjs, dateString: string) => void;
}

export default function StickyDatePicker({ title, value, onChange }: Props) {
  const [visible, setVisible] = useState(false);
  const selected = value && dayjs(value).isValid() ? dayjs(value) : null;
  const currentYear = new Date().getFullYear();
  const selectedYear = selected?.year() ?? currentYear;

  return (
    <>
      <button
        type="button"
        className={styles.h5StickyDateInput}
        onClick={() => setVisible(true)}
        aria-label={title}
        aria-haspopup="dialog"
        aria-expanded={visible}
      >
        <span className={selected ? undefined : styles.h5StickyDatePlaceholder}>
          {selected ? selected.format('YYYY-MM-DD HH:mm') : '请选择时间'}
        </span>
        <img className={styles.h5StickyChevron} src={`${BASE_IMG_URL}/detail/icon_chevron_right.png`} alt="" />
      </button>
      <DatePicker
        title={title}
        visible={visible}
        value={selected?.toDate() ?? null}
        precision="minute"
        min={new Date(Math.min(currentYear - 10, selectedYear), 0, 1)}
        max={new Date(Math.max(currentYear + 10, selectedYear), 11, 31, 23, 59)}
        confirmText="确定"
        cancelText="取消"
        renderLabel={(type, data) => `${data}${({ year: '年', month: '月', day: '日', hour: '时', minute: '分' } as Record<string, string>)[type] || ''}`}
        stopPropagation={['click', 'touchstart']}
        onClose={() => setVisible(false)}
        onConfirm={(date) => {
          const next = dayjs(date);
          onChange(next, next.format('YYYY-MM-DD HH:mm'));
        }}
      />
    </>
  );
}
